import { render, staticRenderFns } from "./VehicleNotes.vue?vue&type=template&id=613946ad"
import script from "./VehicleNotes.vue?vue&type=script&lang=js"
export * from "./VehicleNotes.vue?vue&type=script&lang=js"
import style0 from "./VehicleNotes.vue?vue&type=style&index=0&id=613946ad&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports